import { SERVICES } from "../data";

export const ServicesGrid = () => (
  <section className="section" id="servicos" data-testid="services-section">
    <div className="container">
      <span className="section-tag">Nossos serviços</span>
      <h2>Serviços técnicos 24 horas no litoral</h2>
      <p className="lead">
        Desentupimento no litoral SP com foco em rapidez, limpeza e segurança — 12
        especialidades para residências, comércios, condomínios e indústrias.
      </p>
      <div className="grid cols-3">
        {SERVICES.map((s) => (
          <article className="card" key={s.slug} data-testid={`service-card-${s.slug}`}>
            {s.image && (
              <div className="card-image-wrap">
                <img
                  src={s.image}
                  alt={s.alt}
                  title={s.name}
                  className="card-img"
                  loading="lazy"
                  width="360"
                  height="200"
                />
              </div>
            )}
            <div className="card-body">
              <span className="tag">24 horas</span>
              <h3>{s.name}</h3>
              <p>{s.desc}</p>
              <a className="card-link" href={`/servicos/${s.slug}.html`} data-testid={`service-link-${s.slug}`}>
                Ver serviço
              </a>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
